import React, { useState } from "react";
import leftImage from "../assets/Images/login-image.jpg";
import { useForm } from "react-hook-form"; 
import {
  formBtn1,
  formbutton,
  inputClass,
} from "../Components/Utils/CustomClasses";
import {
  validateEmail,
  validatePassword,
} from "../Components/Utils/Validation";
import Error from "../Components/Error/Error";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setLastSession,
  setLatestBreak,
  setLogin,
  setUserDetails,
  setRole,
} from "../Redux/Slice/LoginSlice";
import barLoader from "../assets/Images/BarLoader.gif";
import { toast } from "react-toastify";
import {
  getLatestBreak,
  getSingleAttendence,
  LoginUserAPI,
  RolesPaginationReduxAPI,
} from "../API/Api";
import { Tooltip } from "antd";
import ForgotPasswordModal from "../Components/Modals/ForgotPasswordModal";
import loginImage from "../assets/Images/LoginImg.png";
import topShape from "../assets/Images/Group 883.png";
import { IconEye, IconEyeOff } from "@tabler/icons-react";

export default function NewLogin() {
  const [eyeIcon, setEyeIcon] = useState(false);
  const [IsOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handlePassword = (e) => {
    e.preventDefault();
    setIsOpen(true);
  };

  const onSubmit = async (data) => {
    setLoadingSpinner(true);
    try {
      const response = await LoginUserAPI(data);
      if (response.status === 200) {
        const user = response?.data?.data?.user;
        localStorage.setItem("Token", response?.data?.data?.accessToken);
        localStorage.setItem(
          "RefreshToken",
          response?.data?.data?.refreshToken,
        );
        dispatch(setLogin(true));
        dispatch(setUserDetails(user));
        dispatch(setRole());
        // Call both APIs after successful login
        Promise.all([
          RolesPaginationReduxAPI({
            companyId: user?.company?._id,
            p: 1,
            records: 100,
          }),
          getSingleAttendence(user?._id),
          getLatestBreak(user?._id),
        ])
          .then(([rolesRes, attendanceRes, breakRes]) => {
            if (rolesRes?.status === 200) {
              dispatch(setRole(rolesRes?.data?.data?.filteredData));
            } else {
              dispatch(setRole(null));
            }
            if (attendanceRes?.status === 200) {
              dispatch(setLastSession(attendanceRes?.data?.data));
            } else {
              dispatch(setLastSession(null));
            }

            if (breakRes?.status === 200) {
              dispatch(setLatestBreak(breakRes?.data?.data));
            } else {
              dispatch(setLatestBreak(null));
            }

            toast.success(response?.data?.message);
            navigate("/");
          })
          .catch((err) => {
            console.error("Error while fetching attendance/break:", err);
          });
      } else {
        toast.error(response?.response?.data?.error);
      }
    } catch (err) {
      console.log("Error:", err);
    } finally {
        setLoadingSpinner(false);
      }
  };

  return (
    
      
          <div className="flex items-center justify-center w-full h-[124vh] bg-[#DBEAFE]">
          <div className="w-full max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-[1146px] bg-white border border-[#D1D5DC] rounded-[16px] overflow-hidden flex flex-col lg:flex-row mx-auto">

          <div className="flex w-full flex-col lg:flex-row">

            {/* LEFT SIDE */}
            <div className="w-full lg:w-[482px] bg-white lg:border-r border-[#D1D5DC] flex flex-col justify-between relative overflow-hidden px-4 sm:px-6 pt-20 sm:pt-20 lg:pt-8 pb-6">

              {/* TOP SHAPE FIXED */}
              <img
                src={topShape}
                alt="design"
                className="absolute top-0 left-0 
                w-[170px] 
                sm:w-[200px] 
                md:w-[240px] 
                lg:w-[320px] 
                object-contain"
              />

              {/* FORM */}
              <div className="w-full">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="w-full max-w-[430px] mx-auto space-y-4 lg:mt-48">
                    {/* TITLE */}
                    <div className="space-y-2">
                      <h1 className="font-[Nata_Sans] text-[22px] sm:text-[26px] md:text-[28px] lg:text-[32px] leading-[140%]">
                        <span className="font-bold text-[#101828]">
                          Welcome to{" "}
                        </span>

                        <span className="font-bold tracking-[0.02em]">
                          <span className="text-[#1814F3] font-extrabold">CRMS</span>
                          <span className="text-[#F87316] font-extrabold">24</span>
                        </span>
                      </h1>

                      <p className="text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] text-[#6A7282] leading-[140%]">
                        Turn every lead into an opportunity. CRM24 enables you to organize, track, and convert leads with complete visibility into your sales pipeline.
                      </p>
                    </div>

                    {/* FORM */}
                    <div className="space-y-3">

                      <input
                        type="email"
                        placeholder="Email"
                        className={`${inputClass} bg-[#F9FAFB] border border-[#D1D5DC]`}
                        {...register("email", { validate: validateEmail })}
                      />
                      {errors.email && <Error title={errors.email.message} />}

                      <div className="relative">
                        <input
                          id="password"
                          name="password"
                          type={!eyeIcon ? "password" : "text"}
                          placeholder="Password"
                          autoComplete="current-password"
                          className={`${inputClass} bg-[#F9FAFB] border border-[#D1D5DC]`}
                          {...register('password',{required:true})}
                        />

                        <span
                          className="absolute right-3 top-3"
                          onClick={() => setEyeIcon(!eyeIcon)}
                        >
                          {eyeIcon ? (
                            <IconEye stroke={1.5} size={24} className="cursor-pointer"/>
                          ) : (
                            <IconEyeOff stroke={1.5} size={24} className="cursor-pointer"/>
                          )}
                        </span>
                        {errors.password && (  <Error title="Password is Required*" /> )}
                      </div>

                      <div className="flex justify-end">
                        <p
                          className="text-[13px] sm:text-[14px] md:text-[15px] cursor-pointer"
                          onClick={handlePassword}
                        >
                          Forgot password?
                        </p>

                        <ForgotPasswordModal
                          IsOpen={IsOpen}
                          setIsOpen={setIsOpen}
                        />
                      </div>

                      <button type="submit" className="flex w-full justify-center font-tbPop rounded-md bg-[#1446E4] px-3 py-2.5 text-base font-semibold leading-6 text-white shadow-sm hover:opacity-70">
                        Sign in
                      </button>

                    </div>
                  </div>
                </form>
              </div>

              {/* ✅ FOOTER FIXED */}
              <div className="mt-6 lg:mt-0 lg:absolute lg:bottom-4 left-0 w-full text-center px-2">
                <p className="text-[12px] sm:text-[13px] lg:text-[14px] text-[#6A7282] leading-[140%]">
                  Designed & Developed by{" "}
                  <a
                    href="https://www.techiebears.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-bold bg-gradient-to-r from-[#BB2222] to-[#F99437] bg-clip-text text-transparent no-underline hover:text-transparent hover:no-underline"
                  >
                    TechieBears Pvt Ltd
                  </a>
                </p>
              </div>

            </div>

            {/* RIGHT SIDE IMAGE */}
            <div className="hidden lg:flex w-[664px] bg-[#F3F4F6] items-center justify-center">
              <img
                src={loginImage}
                alt="Login Illustration"
                className="object-contain w-full h-full"
              />
            </div>

          </div>
        </div>
          </div>
      
     
    
    
      
  );
}
